<template>
  <div class="swiper-thumb__container" style="position:relative">
    <slot name="mark"></slot>
    <div class="swiper-container swiper-gallery" ref="swiperGallery">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(sup, i) in images" :key="i">
          <slot :image="sup">
            <YorkbbsImage class="swiper-thumb__cover" :src="sup | webpFormat(650)"></YorkbbsImage>
          </slot>
        </div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
    <div class="swiper-container swiper-thumbs" ref="swiperThumbs">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(sup, i) in images" :key="i">
          <YorkbbsImage class="swiper-slide__cover" :src="sup | webpFormat(100)" />
        </div>
      </div>
      <div class="swiper-button-next swiper-button-black"></div>
      <div class="swiper-button-prev swiper-button-black"></div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper';
export default {
  name: 'SwiperThumb',
  props: {
    // 图片列表
    images: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    imageLen() {
      return this.images.length;
    },
  },
  watch: {
    imageLen: {
      immediate: true,
      handler(len) {
        if (len > 0) this.initSwiper();
      },
    },
  },
  methods: {
    /**
     * 初始化轮播图
     */
    async initSwiper() {
      await this.$nextTick();
      var galleryThumbs = new Swiper(this.$refs.swiperThumbs, {
        spaceBetween: 10,
        slidesPerView: 6.5,
        slidesPerGroup: 6.5,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        grabCursor: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      new Swiper(this.$refs.swiperGallery, {
        spaceBetween: 10,
        grabCursor: true,
        thumbs: {
          swiper: galleryThumbs,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .swiper-thumbs {
    box-sizing: border-box;
    padding: 0 30px;
    margin: 20px 0;
    .swiper-slide {
      opacity: 0.4;
    }
    .swiper-slide-thumb-active {
      opacity: 1;
    }

    .swiper-button-prev,
    .swiper-button-next {
      width: 20px;
      height: 60px;
      background-color: #eee;
      top: 0;
      margin-top: 0;
      &::after {
        font-size: 20px;
        font-weight: bold;
      }
    }
    .swiper-button-prev {
      left: 0;
    }
    .swiper-button-next {
      right: 0;
    }
  }
  .swiper-gallery {
    .swiper-button-next,
    .swiper-button-prev {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.5);
      color: #111;
      &::after {
        font-size: 20px;
        font-weight: bold;
      }
    }
    .swiper-button-prev {
      left: 30px;
    }
    .swiper-button-next {
      right: 30px;
    }
  }
}

.swiper-thumbs__cover {
  width: 650px;
  height: 400px;
  border-radius: 4px;
  border: 1px solid #eee;
}
.swiper-slide__cover {
  width: 80px;
  height: 60px;
  border: 1px solid #eee;
}
</style>
